"use client";

const tabs = [
  { name: "Overview", href: "#", current: true },
  { name: "Styles", href: "#styles", current: false },
  { name: "Parts", href: "#parts", current: false },
  { name: "Finishing", href: "#finishing", current: false },
];

function classNames(...classes: (string | false | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

const onPress = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  e.preventDefault();
  const target = window.document.getElementById(
    e.currentTarget.href.split("#")[1],
  );
  if (target) {
    window.scrollTo({ top: target.offsetTop - 50, behavior: "smooth" });
  }
};

export default function ProductTabs() {
  return (
    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
      {tabs.map((tab) => (
        <a
          key={tab.name}
          href={tab.href}
          onClick={onPress}
          className={classNames(
            tab.current
              ? "border-blue-500 text-blue-600"
              : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
            "whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium",
          )}
          aria-current={tab.current ? "page" : undefined}
        >
          {tab.name}
        </a>
      ))}
    </nav>
  );
}
